var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('media-chooser',{attrs:{"value":_vm.images,"type":"image","multiple":""},on:{"input":_vm.onImagesChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }